<template>
  <div class="driver-panel-passenger-new">
    <div v-if="t" class="bottom-wrapper" :class="{ 'cannot-accept-yet': nSeconds }">
      <div v-if="isDispatch" class="subtitle">
        <i class="fa fa-kiwi-bird fa-sm has-text-orange" />
        {{ $t("driver.special-dispatch") }}
      </div>
      <div class="subtitle is-5 is-flex">
        <span class="job-type">
          <span v-if="isDelivery">
            <i class="fa fa-box-open fa-lg has-text-black" />
          </span>
          <span v-else>
            <i class="fa fa-user fa-lg has-text-link" />
          </span>
          <span class="job-count" v-if="newJobsCount > 1 && isSuperUser()">{{
            newJobsCount
          }}</span>
        </span>
        <span v-if="t.data.fare" class="bonus" @click="showBonusInfo">
          <span v-if="fareBonus">+{{ this.symbol }}{{ fareBonus }}</span>
          <span v-else style="display: inline-block; width: 30px" />
        </span>
        <span class="pickup-dist" @click="showDistanceHint">{{
          distanceToPickupKM
        }}</span>

        <span v-if="isDelivery" class="new-wait-time" :style="waitTimeBorderStyle" @click="showWaitTimeHint">
          <i class="far fa-clock has-text-grey" style="margin-right: 4px" />
          <span v-if="estimatedWaitTime">{{ estimatedWaitTime }} {{ $t("mins") }}</span>
          <span v-else class="has-text-success">{{ $t("ready") }}</span>
        </span>
        <span v-else class="new-wait-time" style="border: 2px solid var(--success)">
          <i class="far fa-clock has-text-grey" style="margin-right: 4px" />
          <span class="has-text-success">{{ $t("ready") }}</span>
        </span>
      </div>

      <div v-if="scheduledTime(t)">
        <span class="tag is-medium has-text-link scheduled">
          {{ $t("driver.scheduled-pickup-time") }}
          {{ scheduledTime(t) }} ({{ humanTime(t) }})
        </span>
      </div>

      <!-- <div v-if="showDragVerifyHack" style='margin:0 10px; margin-bottom:-10px; margin-top:4px;'>
        <span class="button is-fullwidth is-rounded is-large is-link overflow-btn pulse-btn" @click="accept">
          {{ pickupName }}
        </span>
      </div>

      <div v-if="isLegacyButtons" class="buttons is-centered">
        <button class="button is-success is-rounded is-large accept-btn"
          :class="{ opaque: nSeconds, 'green-border': nSeconds && hasPoints, 'opaque-btn': showDragVerifyHack }"
          :disabled="editing" @click="preAccept">
          <span v-if="nSeconds">{{ nSeconds }}</span>
          <span v-else>{{ $t("driver.accept") }}
            <span v-if="isRetry && isSuperUser()">💣</span>
          </span>
          <span v-if="isPizza" style="margin-left: 4px">🍕</span>
        </button>
        <button class="button is-rounded is-large old-reject-btn" :disabled="editing" @click="rejectImmediately">
          {{ $t("ignore") }}
        </button>
      </div> -->

      <!-- NEW BUTTONS STYLE, not LEGACY... -->
      <!-- <div v-else class="is-flex" style="padding: 10px"> -->
      <div class="is-flex" style="padding: 10px">
        <div v-if="nSeconds" class="button is-success is-rounded is-large is-fullwidth opaque"
          :class="{ 'green-border': hasPoints }" style="height:70px" @click="accept">
          {{ nSeconds }}
        </div>
        <div v-else @click="acceptDoubleClick">
          <drag-verify :width="dragWidth" :height="70" :textSize="'28'" :handlerIcon="'fa fa-angle-right fa-lg'"
            :successIcon="'fa fa-check fa-sm'" :text="$t('driver.slide-or-click')" :circle="true" :successText="'🤞🏼'"
            :background="'lightgreen'" @passcallback="accept" class="has-text-white has-text-weight-semibold"
            :class="{ 'swipe-blue-outline': unlockClick }"></drag-verify>
        </div>
        <div>
          <button class="button is-dark is-rounded reject-btn" :disabled="editing" @click="rejectImmediately">
            <i class="fa fa-times fa-lg" />
          </button>
        </div>
      </div>

      <div class="card" :style="cardColor(t)">
        <div class="card-content">
          <p v-if="t.data.ref" class="single-line no-scrollbar" style="text-align: left; width: 100%; margin-bottom: 6px">
            <span class="order-no">
              <i class="fa fa-receipt fa-sm has-text-grey" />
              &nbsp;{{ ref }}
            </span>
            <span class="shop-name">
              <i class="fa fa-store-alt fa-sm" />
              <span class="link has-text-black">{{ pickupName }}</span>
            </span>
          </p>
          <div class="media">
            <div class="media-left">
              <img class="profile-pic" :src="customerPic" />
            </div>
            <div class="media-content no-scrollbar">
              <p class="is-size-5">
                <span class="single-line">
                  <i class="fa fa-user fa-sm" />
                  <span v-if="t.data.pax" class="pax-cnt">x{{ t.data.pax }}</span>
                  <span>{{ customerName }}</span>

                  <!-- USER TAGS -->
                  <span class="user-tags">
                    <span v-if="unitNumber" class="tag is-grey is-medium">{{
                      unitNumber
                    }}</span>
                  </span>
                </span>
              </p>

              <p class="fare-wrapper">
                <span v-if="isLalamove">
                  <span class="fare is-size-5" style="background-color: #eee">
                    ฿{{ t.data.fare.price }}
                  </span>
                  <span class="fare is-size-5">
                    <img src="../assets/tukpay.png" class="tukpay-logo" />
                  </span>
                </span>
                <span v-else>
                  <span class="fare is-size-5" style="background-color: #eee">
                    <span v-if="t.data.fare">฿{{ t.data.fare.price }}</span>
                    <span v-else class="has-text-success">FREE</span>
                  </span>
                  <span v-if="cash" class="fare has-text-grey is-size-5">
                    {{ $t("cash") }}
                  </span>
                  <span v-if="tukpay">
                    <img src="../assets/tukpay.png" class="tukpay-logo" />
                  </span>
                </span>
              </p>
            </div>
          </div>
          <div v-if="isDelivery">
            <p v-if="paymentRequired" class="payment-info">
              <span v-html="payShopX"></span>
              <!-- <br /> -->
              <span v-if="paymentMethod" class="is-pulled-right has-text-grey">
                <i class="fa fa-user" /><b>{{
                  translatePayment(paymentMethod)
                }}</b>
                <i v-if="changeFor" class="fa fa-coins has-text-link" style="margin-left: 6px"
                  @click="showChangeFor" /></span>
              <!-- <br />
              <span v-html="collectFromCustomerX"></span>
              <span
                v-if="cashback"
                class="has-text-danger has-text-weight-bold"
              >
                <br />
                <span v-html="giveCashbackX"></span>
              </span> -->
            </p>
            <p v-else class="payment-info" style="background-color: lightgreen">
              {{ $t("delivery.already-paid-for") }}
            </p>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-content has-text-left">
          <p style="font-size: 1.3em" :class="{ 'text-shadow': unlockPickupDirections }" @click="gotoPickupDirections">
            <i class="fa fa-map-marker-alt has-text-primary" />
            &nbsp;{{ $t("driver.pickup-at") }}
            <a class="has-text-link">
              {{ pickupName }}
            </a>
          </p>
          <p v-if="t.data.dropoff_stop" @click="showDropoff">
            <i class="fa fa-ellipsis-h" />&nbsp;
            <i class="fa fa-map-marker-alt has-text-link" />&nbsp;
            <span v-if="isShowDropoff || !tripDistance">
              {{ $t("driver.dropoff-at") }}
              <a :href="directionsURL" target="_blank">
                {{ dropoffName }}
              </a>
            </span>
            <span v-else class="link">{{ tripDistance }}</span>
          </p>
          <button class="button is-white has-text-grey share-btn">
            <i class="fa fa-share-alt fa-lg" @click="shareRideRequest" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "../eventBus";
import geo from "@/geo";
import { sounds } from "../functions.js";

import dragVerify from "vue-drag-verify";

export default {
  name: "DriverPanelPassengerNew",
  props: {
    transactions: {
      type: Array,
    },
  },
  components: {
    dragVerify,
  },
  data() {
    return {
      unlockPickupDirections: false,
      unlockClick: false, // for double click accept
      showDragVerifyHack: false,
      showDragVerify: false,
      // dragWidth: window.innerWidth - 20,
      dragWidth: window.innerWidth - 100,
      editing: false,
      requests: 1,
      // drivers: [],
      dispatchTo: null, // driver to dispatch to
      eta: null, // if ETA is set
      isShowDropoff: false,
      timer: 0,
    };
  },
  watch: {
    nSeconds() {
      if (this.nSeconds === 1) sounds("collect3");
    },
  },
  computed: {
    hasPoints() {
      return this.isSuperUser(); // return false;
    },
    isLegacyButtons() {
      return this.driverRole.data.accept_button === "legacy";
    },
    driverRole() {
      return this.$store.getters.getDriverRole;
    },
    changeFor() {
      return this.t.data.delivery.change_for;
    },
    hasBankAccount() {
      return this.driverRole.data.bank_account;
    },
    hasPromptPay() {
      return this.driverRole.data.qr_pic_url;
    },
    paymentMethod() {
      if (!this.t.data.delivery) return null; // only delivery have payment method currently
      return this.t.data.delivery.payment_method;
    },
    //  isDelayedDelivery() {
    //   return this.t.data.delivery.type === "delayed";
    // },
    estimatedWaitTime() {
      var prepTime = 20; // this is the global median
      var confirmedAt = new Date(this.t.data.event_created);
      var timeAgo = (new Date() - confirmedAt) / (1000 * 60);
      var readyIn = Math.round(prepTime - timeAgo); // prep time minus time since shop confirmed
      var waitTime = readyIn - this.estimatedDrivingTime;
      if (waitTime < 0) return 0;
      return Math.round(waitTime);
    },
    waitTimeBorderStyle() {
      var color = "var(--danger)";
      if (this.estimatedWaitTime < 15) color = "orange";
      if (this.estimatedWaitTime < 10) color = "var(--warning)";
      if (this.estimatedWaitTime < 5) color = "var(--success)";
      return `border: 2px solid ${color};`;
    },
    // estimation from redash report "Delivery Driver Confirmed to Arrived at Shop"
    // http://redash.tukbot.com/queries/610#984
    estimatedDrivingTime() {
      var dist = Math.round(this.distanceToPickupMeters / 1000);
      if (dist <= 3) return dist * 4;
      if (dist <= 6) return dist * 3;
      if (dist <= 9) return dist * 2.5;
      return dist * 2;
    },
    retryTransactions() {
      // if (!this.transactions) return null;
      return this.transactions.filter((t) => t.data.retry);
    },
    t() {
      if (!this.transactions) return null;
      if (this.retryTransactions.length) {
        return this.retryTransactions[0];
      }
      return this.transactions[0];
    },
    ref() {
      if (this.t.data.ref_prefix) {
        return this.t.data.ref_prefix + this.t.data.ref;
      }
      return "#" + this.t.data.ref;
    },
    pickupName() {
      if (!this.t.data.pickup_stop.name) return this.$t("ride.pin-location");
      return this.shortenString(this.t.data.pickup_stop.name, 40);
    },
    dropoffName() {
      if (!this.t.data.dropoff_stop.name) return this.$t("ride.pin-location");
      return this.shortenString(this.t.data.dropoff_stop.name, 40);
    },
    showCountdownTimer() {
      if (this.isDelivery) return true; // just express delivery with scheduled time soon
      var countdownWorkflows = ["Public Tuk Tuk", "Motocy"];
      return countdownWorkflows.includes(this.t.workflow_type_name);
    },
    isRetry() {
      return this.t.data.retry;
    },
    isPizza() {
      if (!this.isDelivery) return false;
      return this.t.data.delivery.is_large;
    },
    nSeconds() {
      // return 10; // for dev
      console.log("nSeconds timer", this.timer);
      if (!this.showCountdownTimer) return 0;
      // if (!this.isDelivery) return 0;
      if (this.isRetry) return 0;
      if (this.isDispatch) return 0;
      var now = new Date().getTime();
      var ageSeconds = (now - new Date(this.t.updated_at).getTime()) / 1000; // changed from created_at to updated_at
      var validAtSeconds = (this.distanceToPickupMeters / 1000) * 10; // 5 seconds per km
      var countdown = validAtSeconds - ageSeconds;
      // if (this.$store.getters.driverHasActiveJobs) countdown += 60; // add time if driver has an active job
      if (this.$store.getters.driverHasActiveJobsNotEnroute) countdown += 60;
      else if (this.$store.getters.driverHasActiveJobs) countdown += 15; // add less time if enroute
      if (countdown < 0) return null;
      return Math.round(countdown);
    },
    newJobsCount() {
      // return this.$store.getters.getWorkerTransactionsStateNew.length;
      return this.$store.getters.getDriverTransactionsStateNew.length;
    },
    shopPayYou() {
      var payDriverAmount = Math.abs(this.t.data.delivery.order_value);
      var amount = `<b>${this.symbol}${payDriverAmount}</b>`;
      return `<i class='fa fa-store-alt fa-sm' style='margin-right:6px'></i>
        ${this.$t("delivery.shop-pays-you")} ${amount}`;
    },
    payShopX() {
      // shortened from "Pay the shop $244 cash"
      var orderValue = this.t.data.delivery.order_value;
      if (orderValue < 0) return this.shopPayYou;
      var amount = `<strong>${this.symbol}${orderValue}</strong>`;
      return this.$t("delivery.pay-shop-x", { x: amount });
    },
    collectFromCustomerX() {
      var amount = `<strong>${this.symbol}${this.driverCollectValue}</strong>`;
      return this.$t("delivery.collect-from-customer-x", { x: amount });
    },
    giveCashbackX() {
      var amount = `<strong>${this.symbol}${this.cashback}</strong>`;
      // return this.$t("delivery.give-cashback-x", { x: amount });
      return this.$t("delivery.get-bonus-x", { x: amount });
    },
    isTaxi() {
      return this.t.workflow_type_name === "Taxi";
    },
    customerName() {
      if (!this.t) return null;
      return this.t.customer.name || this.t.customer.phone_number;
    },
    googleMap() {
      var lat = this.t.data.pickup_stop.lat;
      var lon = this.t.data.pickup_stop.lon;
      return `http://www.google.com/maps/place/${lat},${lon}`;
    },
    directionsURL() {
      if (!this.t.data.pickup_stop) return;
      if (!this.t.data.dropoff_stop) return;
      // var current = this.$store.state.userState;
      var scoords = `${this.t.data.pickup_stop.lat},${this.t.data.pickup_stop.lon}`;
      var dcoords = `${this.t.data.dropoff_stop.lat},${this.t.data.dropoff_stop.lon}`;
      // return `https://www.google.com/maps?saddr=${scoords}&daddr=${dcoords}`; //url + coords;
      return this.$h.googleMapsDirectionsURL(scoords, dcoords);
    },
    distanceToPickupMeters() {
      var coords = this.$store.getters.getUserLocation;
      var userLoc = { lat: coords[0], lon: coords[1] };
      return geo.distanceToUserInMeters(this.t.data.pickup_stop, userLoc);
    },
    distanceToPickupKM() {
      var dist = this.distanceToPickupMeters;
      var decimals = 0;
      if (dist < 10000) decimals = 1;
      var km = (dist / 1000).toFixed(decimals);
      return `${km} km`;
    },
    distanceToPickupMsg() {
      var dist = this.distanceToPickupMeters;
      var km = (dist / 1000).toFixed(1);
      return `${km} ${this.$t("driver.distance-to-pickup")}`; //`${km} km to this pickup`;
    },
    tripDistance() {
      if (!this.t.data.fare) return; // private tuk tuk dropoff won't have fare
      if (!this.t.data.fare.distance) return;
      var km = (this.t.data.fare.distance / 1000).toFixed(1);
      return `${km} ${this.$t("driver.km-journey")}`;
    },
    drivers() {
      if (this.$store.state.workflowDrivers) {
        return this.$store.state.workflowDrivers;
      }
      return [];
    },
    unitNumber() {
      if (!this.transactions) return null;
      var t = this.transactions[0];
      if (!t.customer.role) return null;
      if (!t.customer.role.data) return null;
      if (!t.customer.role.data.unit_number) return null;
      return `Unit ${t.customer.role.data.unit_number}`;
    },
    businessPic() {
      var placeholder = this.$store.state.menuItemPlaceholderPic; // change to a shop cartoon?
      if (!this.t.business) return placeholder;
      return this.t.business.profile_pic_url || placeholder;
    },
    customerPic() {
      if (this.t.data.type === "delivery") {
        return this.businessPic;
      }
      return this.t.customer.profile_pic_url || this.fallbackProfPic();
    },
    fareType() {
      return this.t.data.price;
    },
    prettyFare() {
      return this.t.data.price;
    },
    isTukPay() {
      if (this.t.data.payment_method === "tukpay") return true;
      return false;
    },
    cash() {
      if (!this.t.data.fare) return false;
      if (this.t.data.fare.cash !== 0) return true; // there is a cash component
      return false;
    },
    tukpay() {
      if (!this.t.data.fare) return false;
      if (this.t.data.fare.tukpay !== 0) return true; // there is a tukpay component
      return false;
    },
    isDispatch() {
      return this.t.handled_by;
    },
    isDelivery() {
      return this.t.data.type === "delivery";
    },
    orderValue() {
      return this.t.data.delivery.order_value;
    },
    paymentRequired() {
      if (!this.isDelivery) return false;
      if (!this.orderValue) return false;
      var arr = ["cash", "promptpay", "bank-transfer"];
      return arr.includes(this.t.data.delivery.payment_method);
      // if (this.t.data.delivery.payment_method === "cash") return true;
      // return false;
    },
    isLalamove() {
      if (!this.t.data.delivery) return null;
      return this.t.data.delivery.lalamove;
      // return this.t.data.lalamove_order_id;
    },
    driverCollectValue() {
      if (this.isLalamove) return this.orderValue;
      var sum = parseInt(this.orderValue) + parseInt(this.t.data.fare.cash);
      if (this.cashback) return sum - this.cashback;
      return sum;
    },
    cashback() {
      return this.t.data.delivery.cashback;
    },
    symbol() {
      return this.currencySymbol(this.t.business.country);
    },
    fareBonus() {
      if (!this.t.data.fare) return null;
      return this.t.data.fare.bonus || 0;
    },
  },
  // activated() {},
  mounted() {
    setInterval(() => (this.timer += 1), 1000);
  },
  methods: {
    // close() { EventBus.$emit("CLOSE_PASSENGER_NEW", true) },
    showChangeFor() {
      // var msg = `Requested change for <b>${this.symbol}${this.changeFor}</b>`;
      var currencyAmount = { x: `${this.symbol}${this.changeFor}` };
      var msg = this.$t("delivery.requested-change-for-x", currencyAmount);
      this.infoToast(msg);
    },
    showDistanceHint() {
      this.infoToast(this.distanceToPickupMsg);
    },
    showWaitTimeHint() {
      this.infoToast("เวลารอที่ร้านโดยประมาณ"); // Estimated wait time at shop
    },
    showBonusInfo() {
      // var bonus = this.t.data.fare.bonus;
      // var info = `This job pays +${this.symbol}${bonus}<br>more than normal fare`;
      var bonus = { x: `${this.symbol}${this.fareBonus}` };
      var info = this.$t("driver.job-pays-x-more", bonus);
      this.infoToast(info);
    },
    cardColor(t) {
      var age = (new Date() - new Date(t.created_at)) / 1000;
      if (age > 60 && age < 120) return "box-shadow: inset 0 0 0 6px gold";
      if (age > 120) return "box-shadow: inset 0 0 0 6px pink";
    },
    showDropoff() {
      this.isShowDropoff = true;
      setTimeout(() => (this.isShowDropoff = false), 2000);
    },
    viewOrderDetails() {
      var orderValue = parseInt(this.t.data.delivery.order_value);
      var deliveryFee = parseInt(this.t.data.fare.price);
      var total = orderValue + deliveryFee;
      var payment = this.translatePayment(this.t.data.delivery.payment_method);
      var txt1 = this.$t("delivery.payment-method");
      var txt2 = this.$t("price");
      var txt3 = this.$t("home.delivery");
      var txt4 = this.$t("total");
      var symbol = this.currencySymbol(this.t.business.country);
      this.$swal({
        imageUrl: this.t.data.delivery.receipt_pic,
        imageHeight: 400,
        html: `<div style='text-align:left'>
        <i>${txt1}: <strong>${payment}</strong></i><br>
        ${txt2}: ${symbol}${orderValue}<br>
        ${txt3}: ${symbol}${deliveryFee}<br>
        <strong>${txt4}: ${symbol}${total}</strong><br>
        </div>`,
        showCloseButton: true,
        showConfirmButton: false,
      });
    },
    triggerServiceFeeMessage() {
      if (this.t.workflow_type_name !== "Sii Lor") return;
      this.$notify({
        type: "warn",
        group: "driver",
        title: this.$t("driver.service-fee"),
        text: `${this.$t("driver.service-fee-issue")} 🙏🏽`,
        duration: 30000,
        position: "top center",
        ignoreDuplicates: true,
      });
    },
    driverAllowed() {
      // check if nearby_drivers set or not
      if (!this.t.data.nearby_drivers) return true;
      // check the age of the transaction
      var age = (new Date() - new Date(this.t.updated_at)) / 1000;
      if (age > 20) return true;
      // check if driver's userID is in the list or nearby
      var allowedDrivers = this.t.data.nearby_drivers;
      if (allowedDrivers.includes(this.userID())) return true;
      // otherwise driver is not allowed
      this.warningAlert(this.$t("driver.nearest-driver-warning"));
      return false;
    },
    driverHasPaymentMethod() {
      if (!this.t.data.delivery) return true; // not a delivery don't check
      var paymentMethod = this.t.data.delivery.payment_method;
      if (paymentMethod === "bank-transfer" && !this.hasBankAccount)
        return false;
      if (paymentMethod === "promptpay" && !this.hasPromptPay) return false;
      return true;
    },
    deliveryDriverEnrouteTooRecently() {
      if (this.isSuperUser()) return false;
      if (!this.isDelivery || this.isDispatch) return false;
      var block = false;
      this.$store.getters.getWorkerTransactionsStateEnroute.forEach((t) => {
        var seconds = this.secondsAgo(t.data.event_enroute);
        console.log(`event_enroute ${seconds}s ago`);
        if (seconds < 60 * 5) {
          // var name = this.$store.getters.realName;
          // var multipleMsg = `DRIVER ATTEMPTED ANOTHER JOB ENROUTE ${seconds}s [ ${name} ] @ ${this.pickupName}`;
          // this.sendSuperuserNotification(multipleMsg);
          var multipleWarning = this.$t(
            "driver.you-cannot-accept-multiple-jobs"
          );
          this.warningAlert(multipleWarning);
          block = true;
        }
      });
      return block;
    },
    dragVerifyHack() {
      this.showDragVerifyHack = !this.showDragVerifyHack;
    },
    preAccept() {
      if (this.showDragVerify) {
        this.dragVerifyHack();
        return
      }
      this.showDragVerify = true
    },
    gotoPickupDirections() {
      if (!this.unlockPickupDirections) {
        this.infoToast("คลิกอีกครั้งเพื่อขอคำแนะนำ", "top")
        this.unlockPickupDirections = true;
        setTimeout(() => this.unlockPickupDirections = false, 2000);
        return
      }
      window.open(this.googleMap, "_blank")
    },
    acceptDoubleClick() {
      if (!this.unlockClick) {
        this.successToast("คลิกอีกครั้ง", "top")
        this.unlockClick = true;
        setTimeout(() => this.unlockClick = false, 2000);
        return
      }
      this.accept();
    },
    accept() {
      EventBus.$emit("DRIVER_REALLY_START_WORKING");
      if (this.hasPoints && this.nSeconds) {
        this.successToast("TODO: Implement TUK Points", "top")
      }
      if (this.nSeconds) {
        var msg = `<i class='fa fa-hourglass-start'></i>&nbsp;รอ ${this.nSeconds} วินาที<br>ให้คนขับที่ใกล้กว่ากดรับงานก่อน`;
        this.infoToast(msg, "top");
        this.timer = 0; // hack to try to fix timer being stuck
        return;
      }
      if (!this.driverAllowed()) return; // driver can't accept if not allowed
      if (!this.driverHasPaymentMethod()) {
        var pay = this.translatePayment(this.t.data.delivery.payment_method);
        var errMsg = `คุณไม่ยอมรับวิธีการชำระเงิน:<br><b>${pay}</b>`; // You don't accept payment method:
        this.errorToast(errMsg, "top");
        return;
      }
      if (this.deliveryDriverEnrouteTooRecently()) return;
      if (
        this.$store.getters.driverHasActiveJobsNotEnroute &&
        this.isDelivery &&
        !this.isDispatch
      ) {
        // var name = this.$store.getters.realName;
        // var multipleMsg = `DRIVER ATTEMPTED ANOTHER JOB [ ${name} ] @ ${this.pickupName}`;
        // this.sendSuperuserNotification(multipleMsg);
        var multipleWarning = this.$t("driver.you-cannot-accept-multiple-jobs");
        this.warningAlert(multipleWarning);
        if (!this.isSuperUser()) return;
        // return;
      }

      this.triggerServiceFeeMessage();
      EventBus.$emit("FIT_MAP");
      this.editing = true;
      var loader = this.loadingDots();
      // var obj = { driver_distance: this.distanceToPickupMeters }; // data object to append
      var obj = { distance_confirmed: this.distanceToPickupMeters }; // data object to append
      if (this.eta) obj.eta = parseInt(this.eta); //obj = { eta: parseInt(this.eta) };
      var driverID = this.$store.state.user.id; // default you are driver
      if (this.dispatchTo) {
        driverID = this.dispatchTo; // otherwise dispatch
        obj.acknowledged = false;
      }
      this.$store
        .dispatch("patchTransaction", {
          transactionID: this.t.id,
          data: {
            // now setting workflow_id in case alternate driver accepted (sii lor only...)
            // this was causing issue for delivery drivers, but now fixed on backend
            // need to allow workflow_id to be set for certain things like sii lor / motorbike...
            workflow_id: this.$store.getters.getDriverRole.workflow_id,
            state: "confirmed",
            handled_by: driverID,
            data: obj, // data obj appends
          },
        })
        .then(() => this.updateTransactionsForDriver(true))
        .catch((err) => {
          console.error("accept transaction error", err);
          this.warningAlert(this.$t("driver.another-driver-accepted"));
          this.updateTransactionsForDriver(true);
        })
        .finally(() => {
          loader.hide();
          this.editing = false;
        });
    },
    rejectLastRetry() {
      if (!this.isRetry) return;
      if (this.retryTransactions.length !== 1) return;
      // otherwise this is the last retry transaction, so reject all
      // if (this.isSuperUser()) return; // let super users see the rest though
      var allIDs = this.transactions.map((t) => t.id);
      this.$store.commit("rejectAllTransactions", allIDs);
    },
    rejectImmediately() {
      this.$store.commit("rejectTransaction", this.t.id);
      this.rejectLastRetry();
      this.updateTransactionsForDriver(true);
      var loader = this.loadingDots("hotpink");
      setTimeout(() => loader.hide(), 500);
    },
    reject() {
      this.editing = true;
      var txt = this.$t("driver.reject-are-you-sure");

      this.$swal({
        // title: this.$t("driver.reject-are-you-sure"),
        // html: '<i class="fa fa-question fa-4x" />',
        html: `<div style='text-align:left'>
        <p style='font-size:1.3em; margin-bottom:12px'>
        <i class="far fa-times-circle"></i>&nbsp;Ignore the job</p>
        <p>${txt}</p></div>`,
        showCancelButton: true,
        cancelButtonText: this.$t("driver.yes-reject"),
        confirmButtonText: this.$t("no"),
      }).then((result) => {
        this.console("reject result", result);
        this.editing = false;
        if (result.dismiss === "cancel") {
          this.$store.commit("rejectTransaction", this.t.id);
          this.updateTransactionsForDriver(true);
          var loader = this.loadingDots("hotpink");
          setTimeout(() => loader.hide(), 500);
          // this.$store
          //   .dispatch("patchTransaction", {
          //     transactionID: this.transaction.id,
          //     data: { state: "rejected" }
          //   })
        }
      });
    },
    shareRideRequest() {
      if (navigator.share) {
        navigator
          .share({
            text: `📍${this.pickupName}
👉🏼${this.$t("driver.go-to-app-to-take")}`,
          })
          .catch((err) => this.console("Error sharing", err));
      } else {
        this.warningAlert("Sharing not supported by this device!");
      }
    },
  },
};
</script>

<style scoped>
.subtitle {
  margin: 10px;
  margin-bottom: 0;
  /* margin-left: 12px;
  margin-top: 12px; */
}

.profile-pic {
  object-fit: cover;
  height: 80px;
  width: 80px;
  border-radius: 3px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.14);
  background-color: white;
}

.bottom-wrapper {
  z-index: 2;
  position: absolute;
  bottom: 0px;
  left: 0px;
  height: auto;
  min-height: 30%;
  /* height: 30%; */
  width: 100%;
  background-color: white;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  box-shadow: 0px -2px 2px rgba(100, 100, 100, 0.2);
  border-top: 6px solid rgba(34, 255, 0, 0.6);
}

.is-retry {
  border-top: 6px solid hotpink;
}

.cannot-accept-yet {
  border-top: 8px solid gold;
}

.media-left {
  margin-right: 4px;
}

/* .card .media {
  overflow: hidden;
} */
/* .cards {
  overflow: hidden;
  height: 25vh;
  overflow: scroll;
  overflow-x: hidden;
} */
a:active,
a:visited {
  color: blue;
}

.circle {
  border-radius: 50%;
  background-color: red;
  color: white;
  padding: 2px;
  width: 10px;
  height: 10px;
  opacity: 0.8;
}

.job-count {
  border-radius: 50%;
  background-color: var(--danger);
  color: white;
  padding: 0 8px;
  display: inline-block;
}

.tag {
  padding: 0 6px;
}

div.card-content {
  padding: 14px;
}

.distance-message {
  position: relative;
  text-align: center;
  top: -60px;
  width: 100vw;
  height: 0px;
  opacity: 0.85;
}

.buttons {
  margin: 6px;
  margin-top: 16px;
  /* margin-bottom: 6px; */
}

/* .card.media {
  margin-bottom: 0px !important;
} */
.card .media:not(:last-child) {
  margin-bottom: 0px;
}

.share-btn {
  position: absolute;
  right: 6px;
  bottom: 6px;
  padding: 0 10px;
}

.pickup-dist {
  padding: 2px 6px;
  font-weight: 500;
  border: 2px solid #ccc;
  border-radius: 6px;
}

.wait-time {
  padding: 2px 6px;
  position: absolute;
  right: 6px;
  top: 6px;
  font-size: 1.1em;
  border: 2px solid red;
  border-radius: 6px;
  font-weight: 500;
}

.bonus {
  padding: 2px 6px;
  font-weight: 500;
  border: 2px solid var(--info);
  border-radius: 6px;
}

.job-type {
  padding: 2px 6px;
  font-weight: 500;
  border: 2px solid white;
  border-radius: 6px;
}

.new-wait-time {
  padding: 2px 6px;
  border: 2px solid red;
  border-radius: 6px;
  font-weight: 500;
}

.subtitle.is-flex {
  justify-content: space-between;
}

.fa-user,
.fa-store-alt {
  width: 30px;
  text-align: center;
  color: grey;
}

.single-line {
  white-space: nowrap;
  overflow: auto;
}

.user-tags .tag {
  margin-left: 4px;
}

.pax-cnt {
  margin-left: -4px;
  margin-right: 4px;
  font-size: 0.8em;
  font-weight: 550;
}

.fare {
  /* width: 80px; */
  padding: 4px;
  font-weight: 500;
  /* font-size: 1.25em; */
  /* background-color: #eee; */
  line-height: 36px;
  border-radius: 4px;
}

.fare span {
  /* vertical-align: middle; */
  height: 100%;
}

.fare-wrapper {
  margin-left: 4px;
  margin-top: 6px;
  margin-bottom: 10px;
}

.scheduled {
  width: 100%;
  font-weight: 550;
  /* font-size: 1em; */
  margin-top: 10px;
  background-color: yellow;
}

.tukpay-logo {
  height: 22px;
  display: inline-block;
  position: relative;
  top: 6px;
  margin-left: 4px;
  /* filter: drop-shadow(1px 1px 1px white); */
}

.accept-btn {
  width: calc(60%);
}

.old-reject-btn {
  width: calc(40% - 16px);
}

.reject-btn {
  width: 70px;
  height: 70px;
  margin-left: 10px;
}

.opaque {
  opacity: 0.7;
  background-color: red !important;
}

.green-border {
  border: solid 8px greenyellow;
  box-shadow: 0 0 1px black;
  color: greenyellow
}

.order-no {
  text-align: center;
  display: inline-block;
  width: 80px;
  border-radius: 3px;
  border: 1.5px dotted grey;
  margin-right: 6px;
  font-weight: 550;
  /* background-color: lightcyan; */
  background-color: white;
  font-family: "Bookman Old Style", "Times New Roman", Times, serif;
  box-shadow: 0 0 2px grey;
  font-size: 1.2em;
  line-height: 1.2em;
}

.shop-name {
  font-size: 1.1em;
  font-weight: 500;
  color: grey;
}

.payment-info {
  text-align: left;
  background-color: #cff;
  padding: 4px 8px;
  border-radius: 3px;
  box-shadow: 0 0 3px #aaa;
}

.overflow-btn {
  overflow: hidden;
  white-space: nowrap;
  display: block;
  text-overflow: ellipsis;
}

.pulse-btn {
  animation: shadow-pulse-gold 2s ease-out infinite;
  border-radius: 100px;
}

@keyframes shadow-pulse-gold {
  0% {
    box-shadow: inset 0 0 0 0px rgba(255, 255, 0, 1);
  }

  50% {
    box-shadow: inset 0 0 0 6px rgba(255, 255, 0, 0.7);
  }

  100% {
    box-shadow: inset 0 0 0 0px rgba(255, 255, 0, 1);
  }
}

.opaque-btn {
  opacity: 0.3
}

.swipe-blue-outline {
  box-shadow: 0px 0px 3px 3px blue;
}

.text-shadow {
  text-shadow: 0px 0px 1px blue;
}
</style>

